import { COORDINATE_REGEX } from "@/constants/regex";
import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  ReverseGeocodingPayload,
  ReverseGeocodingResponse,
  SearchPlacePayload
} from "@/types/place";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getPlaceApi = async (params?: SearchPlacePayload) => {
  const query = params?.query?.trim();
  const querySize = query?.length ?? 0;
  if (!params || querySize < 3 || COORDINATE_REGEX.test(query ?? "")) return [];

  try {
    const { data } = await axiosInstance.get("/v1/search/place", {
      params
    });

    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getReverseGeocoding = async (
  params?: ReverseGeocodingPayload
): Promise<ReverseGeocodingResponse[] | []> => {
  const isValidCoordinates =
    params && COORDINATE_REGEX.test(`${params.latitude},${params.longitude}`);

  if (!isValidCoordinates) return [];

  try {
    const response = await axiosInstance.get("/v1/geocode/reverse", { params });
    return response.data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};
